import { createFileRoute, redirect } from '@tanstack/react-router';
import { isXeroEnabled } from '@/lib/feature-flags';
import { Scorecard } from '@/components/tracking/Scorecard';
import { FinanceGuard } from '@/components/finance/FinanceGuard';

/**
 * /finance/scorecard — the full F-124 scorecard (per-group metrics, star-to-pin,
 * goals). Flag-gated like the rest of the Xero/finance surfaces: off → the page
 * doesn't exist as far as a builder is concerned; bounce to the finance hub.
 */
export const Route = createFileRoute('/finance/scorecard')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => (
    <FinanceGuard>
      <Scorecard />
    </FinanceGuard>
  ),
});
